import React, { useContext } from 'react';
import { getComponentName } from '@wix/da-react-context/pkg/helpers';

export const SisuContext = React.createContext(false);
SisuContext.displayName = 'SisuContext';

export type WithSisuContextProps = { isSisu?: boolean };

// HOC for convenience...
export function withSisuContext<TProps>(
  Component: React.ComponentType<TProps & WithSisuContextProps>
) {
  const DecoratedComponent: React.FC<TProps> = props => {
    const isSisu = useContext(SisuContext);
    return <Component isSisu={isSisu} {...props} />;
  };
  DecoratedComponent.displayName = `withSisuContext(${getComponentName(
    Component
  )})`;
  return DecoratedComponent;
}
